import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthService, GlobalMessageService, WindowRef, GlobalMessageType, RoutingService, TranslationService, StateWithClientAuth, AuthActions, OAuthLibWrapperService, AuthConfig, OCC_USER_ID_ANONYMOUS, SiteContextActions, AuthRedirectService, UrlPipe, I18nModule } from '@spartacus/core';
import { CustomFormValidators, FormErrorsComponent } from '@spartacus/storefront';
import { from, Observable } from 'rxjs';
import { withLatestFrom, tap, pairwise } from 'rxjs/operators';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { CustomLoginService } from '../custom-login.service';
import { ToastrService } from 'ngx-toastr';
import InventoryManagementService from 'src/app/modules/custom-landing/inventory-unpublished-batch/inventory-management.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CountrieslistComponent } from './countrieslist/countrieslist.component';
import { User } from 'src/app/interfaces/user';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { Store } from '@ngrx/store';
import { LanguageService, UserIdService } from '@spartacus/core';
import { OAuthStorage, DateTimeProvider, OAuthService } from 'angular-oauth2-oidc';
import { CsAgentAuthService, AsmAuthStorageService, AsmAuthService } from '@spartacus/asm/root';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Constants } from 'src/app/core/constants/url.constants';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CdcAuthService } from '@spartacus/cdc/core';
import { FaceidmodalComponent } from '../faceidmodal/faceidmodal.component';
import { GigyaService } from 'src/app/services/gigya.service';
import { CommonPageBreadcrumbsComponent } from '../../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';

declare var gigya: any; 
@Component({
    selector: 'app-custom-login-form',
    templateUrl: './custom-login-form.component.html',
    styleUrls: ['./custom-login-form.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, NgIf, FormsModule, ReactiveFormsModule, FormErrorsComponent, NgClass, RouterLink, AsyncPipe, UrlPipe, I18nModule]
})
export class CustomLoginFormComponent implements OnInit {

  loginForm: UntypedFormGroup;
  notValidCreds = false;
  loginData: any;
  title: any;
  navigationData: any;
  isDisabled = false;
  errorMessage: any;
  OTPForm: UntypedFormGroup;
  privacy: any;
  users: User[];
  email = '';
  password = '';
  useFingerprint = true;
  relUrl: string;
  menuDisplay: any;
  unitArray: any;
  emulatedUser: any;
  inventoryIdToken: string;
  BASE_URL = environment.baseUrl;
  isAsmAccess: any;
  sms: any;
  enableLoader: boolean = false;
  credentials: any;
  isGigyaReady$!: Observable<boolean>;
  toastshown: boolean = false;
  isKeepLoggedIn = false;
  constructor(
    protected auth: AuthService, private csAgentAuthService: CsAgentAuthService, private dateTimeService: DateTimeProvider,
    private customLoginService: CustomLoginService,
    protected globalMessageService: GlobalMessageService,
    protected fb: UntypedFormBuilder,
    protected winRef: WindowRef,
    private router: Router,
    private translation: TranslationService,
    private routingService: RoutingService,
    private customProductService: CustomProductsService,
    private cd: ChangeDetectorRef,
    private toastService: ToastrService,
    private inventoryManagementService: InventoryManagementService, public ModalService: NgbModal,
    protected store: Store<StateWithClientAuth>,private authRedirectService:AuthRedirectService,
    private userIdService: UserIdService, private asmauthstorage: AsmAuthStorageService,
    private oauthStorage: OAuthStorage, protected oAuthLibWrapperService: OAuthLibWrapperService,
    private httpClient: HttpClient, public authcon: AuthConfig, private activatedRoute: ActivatedRoute,private ouathService:OAuthService,
    private toast: ToastService,private customProfileService: CustomProfileService,private languageService:LanguageService,
    private cdcservice: CdcAuthService,
    private gigyaservice: GigyaService) {
    
  }
  
  ngOnInit(): void {
    let asm_enabled = localStorage.getItem('asm_enabled');
    if (asm_enabled == 'true') {
      localStorage.removeItem('asm_enabled');
      this.router.navigate(['/ASM']).then(() => {
        location.reload();
      })
    }
    else {
      localStorage.removeItem('asm_enabled');
    }
    const routeState = this.winRef.nativeWindow?.history?.state;
    this.translation.translate('breadcrumb.login.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.login.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
    this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
      if (previous !== current) {
        if (current != null) {
          if (this.router.url === '/login') {
            this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
          }
        }
      }
    });
    this.inventoryManagementService.getHelpData().subscribe(resp => {
      if (resp) {
        this.privacy=resp
        this.cd.detectChanges();
      }
      else {
        this.toastService.show('Error loading this page:' + (resp));
      }
    });
    // tslint:disable-next-line:no-string-literal
    const prefilledEmail = routeState?.['newUid'];

    this.loginForm = this.fb.group({
      userId: [
        prefilledEmail?.length ? prefilledEmail : '',
        [Validators.required, CustomFormValidators.emailValidator],
      ],
      password: ['', Validators.required],
      otpMethod: ['Email', Validators.required]
    }); 
    this.isGigyaReady$ = this.gigyaservice.isGigyaReady$;
    this.isGigyaReady$.subscribe(isReady => {
      console.log('Gigya is ready:', isReady);
    });
   
  }
  
  submitForm(): void {
    if (this.loginForm.valid) {
      this.isDisabled = true;
      this.checkLoginCreds();
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  protected checkLoginCreds(): any {
    const { userId, password, otpMethod } = this.loginForm.controls;
    this.email = this.loginForm.controls['userId'].value;
    this.password = this.loginForm.controls['password'].value;
    this.gigyaservice.setData({email:this.email,password:this.password});
    this.customLoginService.getUserPwd(password.value);
    // gigya.accounts.login({
    //   loginID:this.email,
    //   password: this.password,
    //   callback:(res)=>{
    //     console.log('CDC login response...', res);
    //   }
    // })
    this.customLoginService.checkUserCredentials(userId.value.toLowerCase(), password.value, otpMethod.value,this.isKeepLoggedIn)
      .subscribe(data => {
        this.isDisabled = false;
        this.notValidCreds = false;
        this.loginData = data;
        this.loginData.password = this.password;
        if (this.loginData.vToken) {
          this.customLoginService.getLoginData(this.loginData);
          this.customLoginService.setRes(this.loginData);
          localStorage.setItem("loginData", JSON.stringify(this.loginData));
          localStorage.setItem("email", this.loginData.email)
          this.customLoginService.setTwoFAType(this.loginForm.controls['otpMethod'].value);
          this.router.navigate(['login/otp']);
          // this.callPasswordExpiry();
        }
        else if (this.loginData.sms_error == 'true') {
          this.customLoginService.getLoginData(this.loginData);
          this.customLoginService.setRes(this.loginData);
          this.customLoginService.setTwoFAType(this.loginForm.controls['otpMethod'].value);
          this.router.navigate(['login/otp']);
        }
        else if (this.loginData.statusCode && this.loginData.statusCode == 403100) {
          this.globalMessageService.add(this.loginData.error, GlobalMessageType.MSG_TYPE_ERROR);
          this.callPasswordExpiry();
        }
        else if (this.loginData.error) {
          // this.callPasswordExpiry();
          this.notValidCreds = false;
          this.notValidCreds = true;
          this.isDisabled = false;
          this.cd.detectChanges();
          this.globalMessageService.add(this.loginData.error, GlobalMessageType.MSG_TYPE_ERROR);
        }
      },
        (err: any) => {
          this.errorMessage = err;
          this.toastService.show("Sorry something went wrong, please try again!")
        });
  }

  protected loginUserCheck(): void {
    const { userId, password, otpMethod } = this.loginForm.controls;
    this.customLoginService.checkUserCredentials(userId.value.toLowerCase(), password.value, otpMethod.value,this.isKeepLoggedIn)
      .pipe(
        withLatestFrom(this.auth.isUserLoggedIn()),
        tap(([_, isLoggedIn]) => {
          if (isLoggedIn) {
            this.routingService.go({
              cxRoute: '',
            });
            // We want to remove error messages on successful login (primary the bad username/password combination)
            // this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
          }
        })
      )
      .subscribe();
  }

  protected loginUser(): void {
    const { userId, password } = this.loginForm.controls;
    from(
      this.auth.loginWithCredentials(
        userId.value.toLowerCase(), // backend accepts lowercase emails only
        password.value
      )
    )
      .pipe(
        withLatestFrom(this.auth.isUserLoggedIn()),
        tap(([_, isLoggedIn]) => {
          if (isLoggedIn) {
            this.routingService.go({
              cxRoute: '',
            });
            // We want to remove error messages on successful login (primary the bad username/password combination)
            this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
          }
        })
      )
      .subscribe();
  }

  callPasswordExpiry() {
    const reqparams = {
      "loginID": this.loginForm.get('userId').value,
      // "apiKey":"4_EaF6D4ULw4QKS67Q-uvmUg",
      // "userKey":"AJMt11cdlAP5",
      // "secret":"QEs5EuDDjWdDqc7v7WAhPw1eqnBbMw5o",
      // "sendEmail":"false"
    }
    this.customLoginService.getPasswordResetToken(reqparams).subscribe(resp => {
      console.log("resp", resp)
      this.router.navigate(['reset-password'], {
        queryParams: {
          pwrt: resp.success
          // apiKey: reqparams.apiKey,
          // pwrt: "tk1AcbHW0G_3w.2LkAaJd8mJElzADS1UF8sQXK5WaMt8Gb_Eo0FhxFK3o78yvLkrxryxXnhmsZ87RA.k1gztnoidCsYjcjvBeD-6GaJEsEEcVDijS4NYCxB-LI1POIa9X892VqMbyDTbSW1QMl2gWgOB2MJWLGScX6ATQ.sc3"
        }
      });
    }, (err => {
      console.log("err", err)
    }))
  }
  openCountriesList() {

    const ModalRef = this.ModalService.open(CountrieslistComponent, { centered: true, size: 'md' });
  }

  getFaceCredentials(){
    // const ModalRef = this.ModalService.open(FaceidmodalComponent, { centered: true, size: 'sm' });
    // ModalRef.componentInstance.modaltoopen = 'firstTime';
    let self = this; 
    gigya.accounts.auth.fido.getCredentials({
      "callback": (response) => {
        self.credentials = response;
        console.log(response)
      }
    })
  }
  test(){
    this.enableLoader = true;
    this.gigyaservice.getCredentials().then(
      (res: any) => {
        this.enableLoader = false;
        this.cd.detectChanges();
        console.log('res....', res);
      }).
      catch((error: any) => {
        console.log('error....', error);
        this.enableLoader = false;
        this.cd.detectChanges();
        this.toast.show('No credentials found for this user!');
      });
    
  }
   registerUser(): void {  
    let self = this; // Capture the service reference
  // const toastService = this.toast; // Capture the service reference
   var email = this.loginForm.controls['userId'].value;
   var password = this.loginForm.controls['password'].value;
   console.log(email,password);
   gigya.accounts.initRegistration({
    "callback": (r) => {
        console.log('initregister...',r); 
        console.log(email,password);
        gigya.accounts.register({
          regToken: r.regToken,
          email: email,
          password: password,
          finalizeRegistration: true,
          preferences: {"terms":{"Terms_Of_Service":{"isConsentGranted":true},"Vendor_terms_of_service":{"isConsentGranted":true}},"privacy":{"Privacy_Policy":{"isConsentGranted":true}}},
          "callback": (response) => {
            console.log("register....",response); 
            gigya.accounts.auth.fido.register({
               regToken: response.regToken,
               "callback": (resp) => {
                console.log('resp', resp);
                if(resp.errorCode === 0){
                  self.toast.show('User registered with Fingerprint Successfully. Please try login with fingerprint.');
                }else{
                  self.toast.show('Error occured while registering user with fingerprint!')
                }
               }
            })
          }
        }
        ) 
    }
   });
   
  }
 
  regsiterusingUID(): void {
    let self = this;
      gigya.accounts.initRegistration({
    "callback": (r) => {
      console.log('initregister...',r);
      gigya.accounts.auth.fido.initRegisterCredentials({
        UID: '675927c7ede84bffa273fe9119463215',
        regToken: r.regToken,
        "callback": (response) => {
          console.log('init register credentials response...', response);
          gigya.accounts.auth.fido.registerCredentials({
        
         // regToken: r.regToken,
               "callback": (resp) => {
                console.log('resp', resp);
                if(resp.errorCode === 0){
                  self.toast.show('User registered with Fingerprint Successfully. Please try login with fingerprint.');
                }else{
                  self.toast.show('Error occured while registering user with fingerprint!')
                }
              }})
        }})
          
    
    
    }})
  }

   removeCredentials(){
    gigya.accounts.auth.fido.removeCredential({
      credentialId: this.credentials.credentials[0].Id,
      "callback": (response) => {
        console.log('remove credentials response...', response);
      }
   })
  }

 loginCDC(){
    var email = this.loginForm.controls['userId'].value;
   var password = this.loginForm.controls['password'].value;
  this.gigyaservice.login(email,password).then((res: any) => {
    console.log('CDC login response...', res);  
  })

    //  gigya.accounts.login({
    //   loginID:this.loginForm.controls['userId'].value,
    //   password: this.loginForm.controls['password'].value,
    //   callback: (res) => {
    //     console.log('CDC login response...', res);
    //     if(res.errorCode === 0){
    //       this.enableLoader = true;
    //       this.gigyaservice.showScreenSet('FIDO-Authentication','gigya-passkey-registration-screen').subscribe({
    //         next: (response:any) => {
    //           this.enableLoader = false;
    //           this.cd.detectChanges();
    //           console.log('response....', response);
    //         },
    //         error: (error:any) => {
    //           console.log('error....', error);
    //           this.enableLoader = false;
    //           this.cd.detectChanges();
    //           this.toast.show('No credentials found for this user!');
    //         },
    //       });
    //      // gigya.accounts.showScreenSet({screenSet:'FIDO-RegistrationLogin', startScreen:'gigya-passkey-registration-screen',});
    //     }
    //     else{
    //       this.toast.show(res.errorMessage);
    //     }
    //   }
    //  })
         
  }
  showScreenSet(){
    const modal = this.ModalService.open(FaceidmodalComponent, { centered: true, size: 'sm' });
    modal.componentInstance.modaltoopen = 'firstTime';
    
  }
  
  login(): void {  
    let toastshown=false;
      this.enableLoader = true;
      this.gigyaservice
        .fidoLogin()
        .then((response: any) => {
          this.enableLoader = false;
          this.cd.detectChanges();
          if (response.errorCode === 0) {
            //this.toast.show('User is logged in successfully using passkey');
            this.translation
              .translate('home.loginForm.Biometrics.successLogin')
              .subscribe((res) => {
                if (!toastshown) {
                  this.toast.show(res);
                  toastshown = true;
                }
              });
            // const parameters = new Object({ username: response.profile.email });
            // const result = this.cdcservice.loginWithCustomCdcFlow(
            //   response.UID,
            //   response.UIDSignature,
            //   response.signatureTimestamp,
            //   response.id_token,
            //   environment.baseSite[0],
            // );
            // console.log('fetch token using grant.....', result);
            // this.userIdService.setUserId('current');
            // this.store.dispatch(new AuthActions.Login());
            // this.authRedirectService.redirect();
            // console.log('bhpunit from login function')
            this.customProfileService
              .getBhpData(response.profile.email)
              .subscribe({
                next: (res) => {
                  if (res) {
                    this.unitArray = res.myB2BUnits;
                    if (this.unitArray.length <= 1) {
                      localStorage.setItem('selectorPref', 'false');
                    } else {
                      localStorage.removeItem('selectorPref');
                    }
                    this.menuDisplay = this.unitArray[0].menuDisplay;
                    var companyCode = this.unitArray.filter((data) => {
                      return data.uiDefaultAccount == true;
                    });
                    localStorage.setItem('groupCompany', companyCode[0].uid);
                    if (companyCode[0]?.menuDisplay) {
                      this.relUrl = '/';
                      this.languageService.setActive(
                        companyCode[0]?.uiDefaultLanguagePref,
                      );
                      this.store.dispatch(
                        new SiteContextActions.SetActiveLanguage(
                          companyCode[0]?.uiDefaultLanguagePref,
                        ),
                      );
                      if (this.relUrl) {
                        localStorage.setItem('defaultLandingPage', this.relUrl);
                      }
                      this.router.navigate([this.relUrl]);
                    } else {
                      this.globalMessageService.add(
                        'Menu Display is not available for the user id, please contact support team',
                        GlobalMessageType.MSG_TYPE_ERROR,
                      );
                    }
                  }
                },
                error: (err: any) => {
                  alert('Some API error might be');
                },
              });
          } else {
            this.toast.show(response.errorDetails);
            this.enableLoader = false;
          }
        })
        .catch((error: any) => {
          this.enableLoader = false;
          this.cd.detectChanges();
          console.log('error....', error.errorDetails);
          //this.toast.show('Error while logging in with passkey');
          this.translation.translate('home.loginForm.Biometrics.errorLogin').subscribe(res=>{   
        if(!toastshown){
          this.toast.show(res);
          toastshown=true;
        }
      })
        });
    
  
        // No need for error handler here, handled in catchError
      
  }
  callscreen(){
    this.loginCDC();
    
 
  }
 
  


}